import CustomProperty from './Modules/CustomProperty.js';

CustomProperty();

window.onload = function () {
  Pagination.init();
};

const Pagination = {
  paginationElm: document.getElementById('js-pagination'),
  paginationObserverElms: document.querySelectorAll('.js-paginationObserver'),
  paginationOpt: {
    rootMargin: '-2px 0px',
    threshold: 0.3,
  },

  init() {
    this.setObserver();
  },

  setObserver() {
    const observer = new IntersectionObserver(
      this.observerCallback.bind(this),
      this.paginationOpt
    );
    this.paginationObserverElms.forEach((elm) => {
      observer.observe(elm);
    });
  },
  observerCallback(entries, object) {
    entries.forEach((entry, i) => {
      const dataClass = entry.target.dataset.class;
      if (dataClass !== '' && typeof dataClass !== 'undefined') {
        const currentClass = 'is-' + dataClass;
        if (entry.isIntersecting) {
          this.paginationElm.classList.add(currentClass);
        } else {
          this.paginationElm.classList.remove(currentClass);
        }
      }
    });
  },
};
